import React from 'react';
import { NavLink } from 'react-router-dom';

const SectorsCrumb = () => <NavLink to="/admin/sectors">Sectors</NavLink>;

export default SectorsCrumb;
